/**
 * Created by Languagenut on 24/07/2019.
 */


import React  from 'react';
import {Button} from 'react-bootstrap'
import 'react-dates/initialize';
import { DateRangePicker} from 'react-dates';
import Table from '../general_table.js';

import ClassesService from '../../services/classes-service.js';
import ClassesStore from '../../store/classes-store.js';
import ProductServices from '../../services/product-service.js';
import Constants from '../../constants.js';
import moment from 'moment';
import Translation from '../../store/internationalization-store.js';

export default class RecentActivity extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:'class_league',
            justMine:false,
            loading:false,
            recentActivity:[],
            startDate:moment().subtract(7, 'days'),
            endDate:moment(),
            isFirst:true,
        };
    }

    getActivity(to , from , language){

        this.setState({
            isFirst:false,
            loading:true,
            recentActivity: []
        });

        ClassesService.getStudentActivity(this.props.studentUid , to , from , language);
    }

    componentWillMount() {
        this.onSearch();
        ClassesStore.on(Constants.GET_STUDENT_ACTIVITY ,  ()=>{
            this.setState({
                loading:false,
                recentActivity:ClassesStore.studentActivity || []
            });
        })
    }

    getSkillTranslation(cell){

        var text = [Translation.get('119' , 'notfound') , Translation.get('117' , 'notfound') , Translation.get('118' , 'notfound'), Translation.get('120' , 'notfound')]

        switch(cell){
            case "reading":
                return text[0]
            case "listening":
                return text[1]
            case "speaking":
                return text[2]
            case "writing":
                return text[3]
            default:
                return "-";
        }
    }

    getTableData(){

        var index = 0;

        var getMedal = function(score){

            if(score < 50) return '-';
            if(score < 70) return Translation.get('269' , 'notfound');
            if(score < 90) return Translation.get('270' , 'notfound');

            return Translation.get('271' , 'notfound');
        }


        return this.state.recentActivity.map(function(activity){

            var test = "-";
            switch(String(activity.is_test)){
                case "1":
                    test=  Translation.get('114' , 'notfound'); break;
                case "0":
                    test =  Translation.get('113' , 'notfound'); break;
                default:
                    return "-";
            }

            var skill = Translation.get('113' , 'notfound');

            if(activity.type == "game" || activity.type == "homework" || activity.type == "exam")
            {
                skill = this.getSkillTranslation(activity.skill);
            }
            else
            {
                switch(activity.type){
                    case "verb" : skill = Translation.get('1026' , 'notfound'); break;
                    case "sentence" : skill = Translation.get('89' , 'notfound'); break;
                    case "grammer" : skill = Translation.get('100' , 'notfound'); break;
                }

            }

            var zeroFill = function( number, width ) {
                width -= number.toString().length;
                if ( width > 0 )
                {
                    return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number;
                }
                return number + ""; // always return a string
            };

            var toTimeString = function(timeStamp){

                timeStamp = Number(timeStamp);

                var decisecond = Math.floor((timeStamp/10000));
                var seconds=Math.floor((timeStamp/1000)%60);
                var minutes=Math.floor((timeStamp/(1000*60))%60);
                var hours=Math.floor((timeStamp/(1000*60*60))%24);

                return zeroFill(hours , 2) +":"+zeroFill(minutes , 2) + ":" + zeroFill(seconds , 2)
            };

            var title = Translation.get(12103, 'Assignment');
            if (activity.title) {
                title = activity.title
            } else if (activity.module_uid) {
                title = Translation.getModuleNoIndexTranslation(activity.module_uid);
            }
            var percentage = activity.precentage + "%";
            if (activity.precentage == null || activity.precentage == undefined) {
                percentage = "-";
            }


            return {
                id:index++,
                language:Translation.get(activity.languageName, "langauge"),
                name:activity.name,
                skill:this.getSkill(activity),
                section:title,
                score:activity.score,
                percentage:percentage,
                medal: activity.is_test == "1" ||  activity.type == "homework" ?  getMedal(activity.precentage) : Translation.get(87, 'Practice'),

                type:activity.type,
                time:toTimeString(activity.time),
                date_time:moment(activity.date_time).format("DD/MM/YYYY HH:MM")
            }
        }.bind(this));
    }

    getSkill(activity){
        if (activity.type == "vocab" || 
            (activity.type != "exam" && activity.type != "verb" && activity.type != "verbs" &&
            activity.type != "grammar" && activity.type != "grammer" && activity.type != "sentence")) {

            let lower = String(activity.skill);
            return "Vocab " + lower.charAt(0).toUpperCase() + lower.substring(1);

        } else if (activity.type == "exam") {
            let lower = String(activity.skill);
            return "Exam " + lower.charAt(0).toUpperCase() + lower.substring(1);
        } else if (activity.type == "grammer" || activity.type == "grammar") {
            return Translation.get('100' , 'notfound');
        } else {
            let lower = String(activity.type);
            return lower.charAt(0).toUpperCase() + lower.substring(1);
        }
    }

    onSearch(){
        var ietf = "all";
        /*
        if ((this.state.language == undefined && language == undefined) 
                || this.state.startDate == null || this.state.endDate == null) {
            return;
        }
        if ((language == undefined || language.ietf == undefined) && this.state.language != undefined) {
            language = this.state.language
        }*/
        this.getActivity(this.state.startDate.unix(), this.state.endDate.unix(), ietf);
    }

    componentDidMount() {
        ProductServices.getAllLanguages();
    }

    render(){

        const columns = [
            {
                dataField: 'language',
                text: Translation.get(492 , 'Language'),
                align: "left",
            },
            {
                dataField: 'date_time',
                text: Translation.get(12613 , 'Completed Date'),
                sort: true,
                align: "left",
            },
            {
                dataField: 'name',
                text: Translation.get(827 , 'Student Name'),
                sort: true,
                align: "left",
            },
            {
                dataField: 'skill',
                text: Translation.get(12612 , 'Learning Skill'),
                sort: false,
                align: "left",
            },
            {
                dataField: 'section',
                text: Translation.get(12325 , 'Task/Section'),
                sort: false,
                align: "left",
            },
            {
                dataField: 'type',
                text: Translation.get(2013 , 'Type'),
                sort: false,
                align: "left",
                hidden:true
            },
            {
                dataField: 'percentage',
                text: Translation.get(12168 , 'Percentage'),
                sort: false,
                align: "left",
            },
            {
                dataField: 'medal',
                text: Translation.get(12682 , 'Medal'),
                align: "left",
            },

       ];

        let search =   <div class="d-flex flex-row-reverse">
            <div style={{paddingTop:".5rem"}}> <Button onClick={this.onSearch.bind(this)}>Search</Button></div>
            <div class="p-2">
                <DateRangePicker
                    displayFormat='DD/MM/YYYY'
                    isOutsideRange={() => false}
                    disabled={false}
                    enableOutsideDays={false}
                    customArrowIcon={<i class="fas fa-arrows-alt-h"></i>}
                    startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                    startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                    endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                    endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                    onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired,
                    focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                    onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                    />
            </div>
        </div>


        return <div>
            <Table  isLoading={this.state.loading} key={'id'} component={search} data={  this.getTableData() || [] } columns={ columns } />
         </div>
    }

}